import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button.jsx";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center text-center">
      <p className="text-xs uppercase tracking-widest text-accent">404</p>
      <h1 className="mt-2 font-display text-3xl text-text-primary">Page not found</h1>
      <p className="mt-2 max-w-md text-sm text-text-secondary">
        {
          "The page you're looking for doesn't exist yet. Phase 9 brings the per-resource CRUD pages online."
        }
      </p>
      <Link to="/" className="mt-6">
        <Button>Back to dashboard</Button>
      </Link>
    </div>
  );
}
